/* Dates: Turkey calendar; religious holidays verified against Diyanet 2026/2027. */
(function () {
  const fixed = new Set(['01-01','04-23','05-01','05-19','07-15','08-30','10-28','10-29']);
  const holidays = new Set(['2026-03-19','2026-03-20','2026-03-21','2026-03-22','2026-05-26','2026-05-27','2026-05-28','2026-05-29','2026-05-30','2027-03-08','2027-03-09','2027-03-10','2027-03-11','2027-05-15','2027-05-16','2027-05-17','2027-05-18','2027-05-19']);
  function estimate(now) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Istanbul',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
    const date = new Date(Date.UTC(+parts.year,+parts.month-1,+parts.day));
    let remaining=2;
    while(remaining){date.setUTCDate(date.getUTCDate()+1);const key=date.toISOString().slice(0,10);if(![0,6].includes(date.getUTCDay())&&!fixed.has(key.slice(5))&&!holidays.has(key))remaining--;}
    const minutes=Math.ceil((86400-(+parts.hour*3600+ +parts.minute*60+ +parts.second))/60);
    return {date:date.toISOString().slice(0,10),label:new Intl.DateTimeFormat('tr-TR',{timeZone:'UTC',day:'numeric',month:'long',weekday:'long'}).format(date),countdown:`${Math.floor(minutes/60)} saat ${minutes%60} dakika`,supported:+parts.year<=2027&&date.getUTCFullYear()<=2027};
  }
  const COOKIE = 'pb_fast_shipping_v2';
  const MINUTE = 60000;
  function nextHour(now) {
    const date = new Date(now);
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/Istanbul', minute: '2-digit', second: '2-digit'}).formatToParts(date).map(part => [part.type, part.value]));
    const elapsed = (Number(parts.minute) * 60 + Number(parts.second)) * 1000 + date.getUTCMilliseconds();
    return now + 60 * MINUTE - elapsed;
  }
  function createReservation(now) {
    return {version: 2, startedAt: now, expiresAt: nextHour(now), extended: false};
  }
  function parseReservation(value) {
    try {
      const state = JSON.parse(value);
      if (state.version !== 2 || !Number.isSafeInteger(state.startedAt) || !Number.isSafeInteger(state.expiresAt) || typeof state.extended !== 'boolean') return null;
      const initialDeadline = state.expiresAt - (state.extended ? 10 * MINUTE : 0);
      if (initialDeadline !== nextHour(state.startedAt)) return null;
      return state;
    } catch { return null; }
  }
  function remainingSeconds(state, now) {
    return state ? Math.max(0, Math.ceil((state.expiresAt - now) / 1000)) : 0;
  }
  function canExtend(state, now) {
    return Boolean(state && !state.extended && state.expiresAt > now && state.expiresAt - now <= MINUTE);
  }
  function extendReservation(state, now) {
    return canExtend(state, now) ? {...state, expiresAt: state.expiresAt + 10 * MINUTE, extended: true} : state;
  }
  function displayTime(seconds) {
    return `${Math.floor(seconds / 60)} dakika ${String(seconds % 60).padStart(2, '0')} saniye`;
  }
  function orderAttributes(state, now) {
    const format = value => value ? new Date(value).toISOString() : '';
    return {
      'Hızlı kargo rezervasyonu': !state ? 'Kaydedilemedi' : (state.expiresAt > now ? 'Süreli rezervasyon' : 'Süre doldu'),
      'Hızlı kargo başlangıcı (UTC)': format(state?.startedAt),
      'Hızlı kargo bitişi (UTC)': format(state?.expiresAt),
      'Hızlı kargo süre uzatması': state?.extended ? '10 dakika' : 'Yok'
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {estimate, nextHour, createReservation, parseReservation, remainingSeconds, canExtend, extendReservation, displayTime, orderAttributes};
  if (typeof document === 'undefined' || window.pbDeliveryReady) return;
  window.pbDeliveryReady = true;
  function readCookie() {
    try {
      const value = document.cookie.split('; ').find(part => part.startsWith(COOKIE + '='));
      return value === undefined ? undefined : parseReservation(decodeURIComponent(value.slice(COOKIE.length + 1)));
    } catch { return null; }
  }
  function writeCookie(state) {
    try {
      // No Expires/Max-Age: one first-party browser session, shared by its tabs.
      document.cookie = `${COOKIE}=${encodeURIComponent(JSON.stringify(state))}; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
      const saved = readCookie();
      return saved?.startedAt === state.startedAt && saved?.expiresAt === state.expiresAt ? saved : null;
    } catch { return null; }
  }
  let state = readCookie();
  if (state === undefined) state = writeCookie(createReservation(Date.now()));
  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }
  function syncOrderAttributes(now) {
    document.querySelectorAll('[data-pb-cart-form]').forEach(form => {
      Object.entries(orderAttributes(state, now)).forEach(([key, value]) => {
        const name = `attributes[${key}]`;
        let input = Array.from(form.querySelectorAll('[data-pb-reservation-attribute]')).find(field => field.name === name);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden'; input.name = name; input.dataset.pbReservationAttribute = '';
          form.append(input);
        }
        input.value = value;
      });
    });
  }
  function render() {
    state = readCookie() || null;
    const now = Date.now(), seconds = remainingSeconds(state, now), active = Boolean(state && seconds > 0);
    const info = estimate(new Date(now));
    document.querySelectorAll('[data-pb-delivery]').forEach(box => {
      const message = box.querySelector('[data-delivery-message]');
      const timer = box.querySelector('[data-reservation-time]');
      const text = box.querySelector('[data-delivery-text]');
      const extend = box.querySelector('[data-reservation-extend]');
      if (!timer || !extend) return;
      box.dataset.reservationState = active ? 'active' : (state ? 'expired' : 'unavailable');
      timer.hidden = !active;
      if (active) setText(timer, displayTime(seconds));
      setText(text, active
        ? (info.supported ? `içinde sipariş verin, ${info.label} tahminen kapınızda.` : 'içinde sipariş verin, tahminen 2 iş gününde kapınızda.')
        : (state ? 'Hızlı kargo süresi doldu. Ücretsiz standart kargoyla devam edebilirsiniz.' : 'Teslimat ve kargo bilgilerini ödeme adımında kontrol edebilirsiniz.'));
      extend.hidden = !canExtend(state, now);
      if (document.activeElement === extend && extend.hidden) message?.focus({preventScroll: true});
    });
    syncOrderAttributes(now);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-reservation-extend]');
    if (!button) return;
    const current = readCookie(), now = Date.now();
    if (!canExtend(current, now)) { render(); return; }
    const updated = extendReservation(current, now);
    state = writeCookie(updated);
    render();
    const status = button.closest('[data-pb-delivery]')?.querySelector('[data-reservation-status]');
    setText(status, state ? 'Sürenize 10 dakika eklendi.' : 'Süre uzatması kaydedilemedi.');
  });
  // Refresh timestamps before native checkout submission or AJAX cart update.
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-pb-cart-form]')) render();
  }, true);
  document.addEventListener('visibilitychange', render);
  document.addEventListener('shopify:section:load', render);
  document.addEventListener('pb:cart-updated', render);
  window.addEventListener('pageshow', render);
  render();
  setInterval(() => { if (!document.hidden) render(); }, 1000);
})();
